import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { ConfigService } from "../../services/configService";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { Component } from "../../objects/components/component";
import { User } from "../../objects/users/user";
import { Permission } from "../../objects/groups/permissionScope";
import { StorageManager } from "../managers/storageManager";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private configService: ConfigService, private storageManager: StorageManager, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

        if (!Cookie.get(this.configService.config.ApiTokenCookieName) || !Cookie.get(this.configService.config.UserCookieName)) {
            this.storageManager.setCurrentUser(null);
            this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        return this.storageManager.getCurrentUser().then(user => {

            if (user == null) {
                this.storageManager.setCurrentUser(null);
                this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }


            if (route.data && route.data['componentID'] && !this.canAccess(route.data['componentID'], user)) {
                if (this.hasPermission(user, 10, Permission.Read)) {
                    this.router.navigate(['']);
                }
                else if (this.hasPermission(user, 1, Permission.Read)) {
                    this.router.navigate(['/management/agent'])
                }
                else {
                    this.storageManager.setCurrentUser(null);
                    this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
                }
                return false;
            }


            return true;
        });
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        return this.canActivate(childRoute, state);
    }

    private hasPermission(currentUser: User, componentId: number, permission: Permission): boolean {
        let hasPermission = false;

        for (let group of currentUser.Groups) {
            hasPermission = group.PermissionScopes.find(x => x.ComponentId == componentId && x.Permissions.indexOf(permission) != -1) != null;

            if (hasPermission)
                break;
        }

        return hasPermission;
    }

    private canAccess(currentComponent: Component, currentUser: User): boolean {
        return this.hasPermission(currentUser, currentComponent, Permission.Read);
    }

}


// WEBPACK FOOTER //
// ./app/common/guards/authGuard.ts